<template>
<div>
 <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
   </div>
   <!-- <div class="admin-load" >

<div class="admin-loader" id="admin-loader"></div>
<div class="admin-loader" id="admin-loader2"></div>
<div class="admin-loader" id="admin-loader3"></div>
<div class="admin-loader" id="admin-loader4"></div>

<span id="admin-text">LOADING...</span>

   </div> -->
    <!-- <div class="my-add-spinner" v-if="loading">
        <div class="my-add-spinner-text">Loading</div>
        <div class="my-add-spinner-sector my-add-spinner-sector-red"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-blue"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-green"></div>
      </div> -->

 <!-- <div v-if="loading1" class="mx-auto pt-5 col-12 col-sm-8 col-md-6">
    <div class="spinner">
        <div class="spinner-text">Updating</div>
        <div class="spinner-sector spinner-sector-red"></div>
        <div class="spinner-sector spinner-sector-blue"></div>
        <div class="spinner-sector spinner-sector-green"></div>
      </div>
 </div> -->
  <div class="" v-if="changed">
     <b-container class="col-lg-10 mt-5">
       <h3 class="text-info text-center pt-4 my-4">All Orders</h3>
    <!-- User Interface controls -->
    <b-row>
      <!-- <b-col sm="4" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
      <b-col sm="5" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">Sort By</option>
            </b-form-select>
            <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
     
      <b-col sm="3" class="my-1">
        <b-form-group horizontal class="mb-0">
          <b-form-select v-model="perPage">
            <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="40">40</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table show-empty
             stacked="sm"
             :items="items"
             :fields="fields"
             :hover="true"
              head-variant="dark"
             :current-page="currentPage"
             :per-page="perPage"
              :empty-text="emptyText"
             :filter="filter"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             @filtered="onFiltered"
             class="mt-4">
    
    <template slot="index" slot-scope="data">
      {{data.index + 1}}
    </template>
    <template slot="name" slot-scope="row">
           <b-media>
    <b-img slot="aside" src="https://lorempixel.com/125/125/technics/8/" width="64" height="64"   alt="image" />
      <h6 class="mt-4">{{row.value}}</h6>
      
    </b-media>
      </template>
      <template slot="category" slot-scope="row" class="mt-4">
           <div class="row mt-4">{{row.value}}
           </div>
           </template>
     
      <template slot="actions" slot-scope="row" >
           <div class="btn-group" role="group" aria-label="Basic example">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        
        <a size="sm" @click.stop="row.toggleDetails" class="btn btn-sm btn-info text-white">
         View
        </a>
        <a size="sm" @click="deleteOrder(row.item.id)" class="btn btn-sm btn-danger text-white ">
        Delete
        </a>
        
           </div>
      </template>
      
      <template slot="row-details" slot-scope="row">
        <b-card>
          <ul>
            <!-- <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li> -->
            <!-- <template class="" v-for="(item, key) in row.item" >
              <div :key="key"> -->
                <h5 class="text-center text-info">Customer Details</h5>
                <li class="my-1 mr-2">Customer Name: <span class="ml-2">{{row.item.cusname}}</span></li>
                <li class="my-1 mr-2">Email: <span class="ml-2">{{row.item.cusemail}}</span></li>
                <li class="my-1 mr-2">Telephone: <span class="ml-2">0{{row.item.telno}}</span></li>
                <li class="my-1 mr-2">Address: <span class="ml-2">{{row.item.address}}</span></li>
                <li class="my-1 mr-2">Cart Total Rs: <span class="ml-2">{{row.item.total}}</span></li>
              <!-- </div>
            </template> -->
          </ul>
          <h5 class="text-center text-info  my-4">Ordeded Items</h5>
          <div class="row">
            
          <template class="" v-for="(item, key) in row.item.products" >
          <div class="col-12 col-sm-4 col-lg-3" style="" :key="key">
            <img class="card-img-top" :src="item.image" alt="image">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">{{item.name}}</li>
              <li class="list-group-item"><span>Rs</span> {{item.price}}</li>
              <li class="list-group-item"><span>Quantity</span> {{item.quantity}}</li>
              <li class="list-group-item"><span>Total Rs</span> {{item.subTotal}}</li>
            </ul>
          </div>
          </template>
          </div>
        </b-card>
      </template>
    </b-table>
     <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    <!-- Info modal -->
    <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
     
  </b-container>
  </div>
</div>
</template>

<script>
import db from '../../config/FirebaseInit'
import firebase from "firebase/app"
const items = []
export default {
  name:'orders',
  data () {
    return {
      emptyText:'Loading Records...',
      items: [],
      fields: [
        'index',
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: 'cusname', label: 'Customer name', sortable: true },
        { key: 'cusemail', label: 'Email', sortable: true },
        { key: 'telno', label: 'Tel No' },
        { key: 'total', label: 'Total (RS)', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
        productId:'',
         currentPage: 1,
        perPage: 10,
        totalRows: items.length,
        pageOptions: ['Per Page', 5, 10, 15 ],
        sortBy: null,
        sortDesc: false,
        filter: null,
        isLoggedIn: false,
        currentUser: false,
        modalInfo: { title: '', content: '' },
        loading:false,
        loading1:false,
        loading2:false,
        changed:false,
        shops:[],
        orders:''
       
    }
  },

   computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    deleteOrder(id){
        this.loading2 = true
        this.changed = false
        db.collection('orders').doc(id).delete()
        .then(() => {
          console.log('item deleted', id)
           var newitems = this.items.filter( (item) => {
          console.log('filfkkk')
            return item.id !== id
             
          })
          this.items = newitems
          this.loading2 = false
          this.changed = true
          if(this.items.length == 0){
          this.emptyText = 'There are no records to show'
        }
          console.log(this.items)
          this.orders -= 1
           db.collection("shops").doc(this.shops[0].id)
					.update({
					orders: this.orders
					})
					.then(doc => {
					console.log('doc is', doc)
					})
					.catch(error => alert(error));
		})
	 .catch(error => alert(error));
    },

    info (item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getId(item){
      console.log('getId fun invoked')
      this.productId = item.id
      console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
     backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
  },
 created () {
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop()
     this.loading = true
     this.changed = false
    db.collection('orders').where("shopid", "==", firebase.auth().currentUser.uid).get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id' : doc.id,
          'cusname': doc.data().uname,
          'telno' : doc.data().telno,
          'address': doc.data().address,
          'cusemail': doc.data().uemail,
          'products': doc.data().products,
          'total': doc.data().total
        }
        this.items.push(data)
         
          
      })
      if(this.items.length == 0){
          this.emptyText = 'There are no records to show'
        }
        this.loading = false
        this.changed = true
    })
     db.collection('shops').where("owner", "==", firebase.auth().currentUser.uid)
      .get().then(querySnapshot => {
        
      querySnapshot.forEach(doc => {
        const data = {
		  'id' : doc.id,
		  'orders': doc.data().orders
        }
		this.shops.push(data)
		this.orders = this.shops[0].orders
	  })
	  })
 // })
   
  },
}
</script>

<style scoped>
@import url('~@/assets/admin/css/admin-loader.css');

</style>




// WEBPACK FOOTER //
// src/components/admin/Orders.vue